"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { FileEdit } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import useRealEstateDetail from "@/hooks/QueryHooks/useRealEstateDetail";
import { MobileMenuItem } from "@/components/atoms/MobileMenuItem";
import { ShareTargets } from "@/components/molecules/share/ShareTargets";
import { detailPathForListing } from "../../locationTrail";
type ShareOptionsProps = {
  slug: string;
  title: string;
};
export function ShareOptions(t0) {
  const $ = _c(18);
  const {
    slug,
    title
  } = t0;
  const t = useTranslations("modules.realEstateDetail");
  const locale = useLocale();
  let t1;
  if ($[0] !== slug) {
    t1 = {
      realEstateSlug: slug
    };
    $[0] = slug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const realEstateDetail = useRealEstateDetail(t1);
  const locations = realEstateDetail.data?.data?.locations;
  let t2;
  if ($[2] !== locale || $[3] !== locations || $[4] !== slug) {
    t2 = () => {
      const path = detailPathForListing(locations ?? [], slug);
      const base = (process.env.NEXT_PUBLIC_SITE_URL || "https://casastep.com").replace("://www.", "://");
      return `${base}/${locale}${path}`;
    };
    $[2] = locale;
    $[3] = locations;
    $[4] = slug;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getUrl = t2;
  const t3 = getUrl();
  let t4;
  if ($[6] !== t) {
    t4 = t("shareSocial");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FileEdit />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("createPost");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <MobileMenuItem icon={t5} title={t6} soon={true} disabled={true} data-sentry-element="MobileMenuItem" data-sentry-source-file="ShareOptions.tsx" />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t7 || $[16] !== title) {
    t8 = <ShareTargets url={t3} title={title} heading={t4} data-sentry-element="ShareTargets" data-sentry-component="ShareOptions" data-sentry-source-file="ShareOptions.tsx">{t7}</ShareTargets>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = title;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}